<mat-tab-group color="accent" class="datatables-tabs" animationDuration="0ms">
    <mat-tab [label]="'invest.eval.results.title.shortLabel' | translate">
        <app-results [items]="invest.results?.items" [itemsTitle]="invest.results?.itemsTitle"></app-results>
    </mat-tab>
    <mat-tab [label]="'invest.eval.loaning.title.shortLabel' | translate">
        <app-loaning  [interests]="invest.loaning?.interests" [depreciations]="invest.loaning?.depreciations"></app-loaning>
    </mat-tab>
    <!-- <mat-tab [label]="'invest.eval.rateCurve.title.shortLabel' | translate">
        <app-results [items]="invest.rateCurve"></app-results>
    </mat-tab> -->
</mat-tab-group>
